export default __webpack_public_path__ + "static/media/vertical_expand.504c8914.svg";